
import { Component, OnInit } from '@angular/core';
import { ColumnHeader } from 'src/app/models/column-header';
import { Labels } from 'src/app/constants/labels';
import { SrcPath } from 'src/app/constants/srcPath';
import { GridApi, GridOptions, ModuleRegistry } from 'ag-grid-community';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/constants/routerPath';
import { ButtonRendererComponent } from 'src/app/components/renderer/button-renderer.component';
import { KEYS } from 'src/app/constants/keys';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { getStaticPageId, dateFormatTypeOptions, isPresent, isData, selectTypeOptions } from 'src/app/utils/utils';

import { UserPageDetails } from 'src/app/models/user-page-details';
import { isNullOrUndefined } from 'is-what';
import { AddMoreinfoTabSettingComponent } from 'src/app/components/modal/add-moreinfo-tab-setting/add-moreinfo-tab-setting.component';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { SharedModule } from 'src/app/shared/shared.module';
declare var $: any;
@Component({
  selector: 'app-more-info-tab-setting',
  templateUrl: './more-info-tab-setting.component.html',
  styleUrls: ['./more-info-tab-setting.component.scss'],
  imports:[AgGridAngular,SharedModule]
})
export class MoreInfoTabSettingComponent implements OnInit {

  pageDetails!: UserPageDetails;
  headerData: ColumnHeader | any;
  moreInfoMasterLabel = Labels.moreInfoTabSetting;
  moreInfoDeleteLabel = Labels.moreInfoTabDelete;
  moreInfoDeleteLabelActive = Labels.messages.deleteConfirmactiveMoreInfoTab;
  auditTrialLabel = Labels.auditTrial;
  auditLabel = Labels.auditStaticTrial;
  selectTypeOption = selectTypeOptions;

  public gridOptions: GridOptions | any;
  public gridOptionsApi: GridApi | any;
  moreInfoList: any = [];
  submitted = false;
  modalRef!: BsModalRef;
  labelMessages = Labels.messages;
  editMoreInfoFlag: boolean = false;
  editData: any = [];
  moreInfoId: any;

  updateright = 'true';
  addright = 'true';
  deleteright = 'true';
  pageId: any;
  controllistArray: any;
  auditBtnMainRight: any;
  custDateFormat: string | any;
  dateForamatSaveTypeOption = dateFormatTypeOptions;
  formatCustomer: any = [];
  gridApi: GridApi | any;
  messageLabel = Labels.messages;
  constructor(
    private toastr: ToastrService,
    public modalService: BsModalService,
    private commonService: CommonService,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.gridOptions = <GridOptions>{}
    this.gridOptions.columnDefs = [
      { field: 'SI', sortable: true, valueGetter: (params: any) => params.node.rowIndex + 1, maxWidth: 80, resizable: true },
      { headerName: 'More Info Tab Name', headerTooltip: 'More Info Tab Name', field: 'tabname', tooltipField: 'tabname', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { headerName: 'Linked Column', headerTooltip: 'Linked Column', field: 'linked_column', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { headerName: 'Is Valid', headerTooltip: 'Is Valid', field: 'is_valid', sortable: true, filter: true, floatingFilter: true, resizable: true },
      { headerName: 'Created Date', headerTooltip: 'Created Date', field: 'createddate', sortable: true, filter: true, floatingFilter: true, resizable: true },
      {
        headerName: 'Delete',
        maxWidth: 220,
        cellRenderer: ButtonRendererComponent,
        cellRendererParams: {
          onClick: this.deleteMoreInfoTab.bind(this),
          label: 'trash'
        }
      }
    ]
    this.gridOptions.rowData = [],
      this.gridOptions.rowSelection = 'single',
      // this.gridOptions.onCellClicked = this.openModal.bind(this);
      this.gridOptions.suppressHorizontalScroll = true;
  }

  ngOnInit(): void {
    this.custDateFormat = (sessionStorage.getItem(KEYS.customerDateFormat)!);
    if (isPresent(this.dateForamatSaveTypeOption.filter(s => s.name == this.custDateFormat))) {
      this.formatCustomer = this.dateForamatSaveTypeOption.filter(s => s.name == this.custDateFormat)[0];
    }
    else {
      this.formatCustomer = this.dateForamatSaveTypeOption[0];
    }
    this.setControlRights();
    this.submitted = false;
    this.editMoreInfoFlag = false;
    this.initPageHeader();
    this.loadMoreInfoTabSetting();
    this.loadHeightVale();
    this.pageId = getStaticPageId('MoreInfo Tab Setting');
  }
  loadHeightVale() {
    let screenHeight = screen.height;
    this.commonService.ogLog(screenHeight, "screenHeight")
    let totalGridHeight = screenHeight - 340;
    if (totalGridHeight < 0) {
    } else {
      $(".ag-theme-balham").height(totalGridHeight)
    }
  }

  setControlRights() {
    let pageId = getStaticPageId('MoreInfo Tab Setting');
    this.commonService.getControlRightsForStatic(pageId, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe((data: any) => {
      if (data['table']) {
        this.updateright = data['table'][0].gstibo_updateright;
        this.addright = data['table'][0].gstibo_saveright;
        this.deleteright = data['table'][0].gstibo_deleteright;
      }
      this.initPageHeader();
    });
    this.commonService.moreControlLoadStatic(pageId, this.commonService.getUserCredentials(KEYS.credential_account_id), 1).subscribe((data: any) => {
      if (isData(data) && data['table'].length > 0) {
        this.controllistArray = data['table'];
        this.auditBtnMainRight = this.controllistArray.filter((p: any) => p.gstibo_control_name == 'auditTrial0')[0].gstibo_has_right;
      }
      this.initPageHeader();
    });
  }

  onGridReady(params: any) {
    this.gridOptions.api = params.api;
    this.gridOptionsApi.sizeColumnsToFit();
    this.loadMoreInfoTabSetting();

    const firstIconbt = document.getElementsByClassName("ag-paging-button")[0];
    firstIconbt.id = "btFirstIcon";
    $('#btFirstIcon').prop('title', 'Start');

    const preIconbt = document.getElementsByClassName("ag-paging-button")[1];
    preIconbt.id = "btPrevIcon";
    $('#btPrevIcon').prop('title', 'Previous');

    const nextIconbt = document.getElementsByClassName("ag-paging-button")[2];
    nextIconbt.id = "btNextIcon";
    $('#btNextIcon').prop('title', 'Next');

    const lastIconbt = document.getElementsByClassName("ag-paging-button")[3];
    lastIconbt.id = "btLasttIcon";
    $('#btLasttIcon').prop('title', 'End');
  }

  initPageHeader() {
    this.headerData = {
      title: this.moreInfoMasterLabel.title,
      title_parent1: '',// Labels.title.settings,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.moreInfoMasterLabel.addButtonTitle,
            icon: SrcPath.addIcon,
            class: this.moreInfoMasterLabel.class + (this.addright == 'false' ? ' disable-click' : ''),
            lblname: this.moreInfoMasterLabel.lblAdd
          },
          {
            title: this.labelMessages.page_creation.page_back,
            icon: SrcPath.previousIcon,
            class: this.labelMessages.page_creation.page_class_back11
          },
        ]
      }
    };
  }

  loadMoreInfoTabSetting() {
    let tabid = 0;
    this.commonService.loadMoreInfoTabSetting(tabid).subscribe((data: any) => {
      this.commonService.ogLog(data['table'], 'loadMoreInfoTabSetting');
      if (isData(data)) {
        const datas = data['table'];
        this.moreInfoList = datas;
        datas.forEach((element: any) => {
          this.gridOptions.rowData?.push(
            {
              'id': element.more_info_id,
              'tabname': element.tabname,
              'linked_column': element.linked_column,
              'createddate': this.datePipe.transform(element.created_date, this.formatCustomer.id.toString()),
              'is_valid': element.is_valid,
              'gstibo_linked_table': element.gstibo_linked_table
            }
          );
        });
      } else {
        this.commonService.ogLog('data not available');
      }
      this.commonService.ogLog(this.gridOptions.rowData, "data")
      if (this.gridApi)
        this.gridOptionsApi.setRowData(this.gridOptions.rowData!);
    },
      error => {
        console.log('get moreinfo tab list Error:', error);
      });
  }

  openModal(e: any, actionname: any) {
    if (actionname == this.auditLabel.title) {
      const pageDetails = {
        pageId: getStaticPageId('MoreInfo Tab Setting'),
        pagePrimaryKey: 0,
        staticpage: 1,
        pageName: "MoreInfo Tab Setting"
      }
      sessionStorage.setItem(KEYS.subPageDetails, JSON.stringify(pageDetails));
      sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
      this.commonService.ogLog('pageNAME', JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!).pageName);
      const path = RoutePath.auditTrialPage.replace(':page_name', JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!).pageName);
      this.router.navigate([path]);
    }
    else {
      this.editMoreInfoFlag = false;
      this.moreInfoId = 0;
      if (e.data) {
        this.moreInfoId = e.data.id;
        if (this.moreInfoId > 0) {
          this.editMoreInfoFlag = true;
        }
      }
      //const config: ModalOptions = { class: KEYS.modalConfigNormalClass, backdrop: "static" }
      let config: ModalOptions = { class: KEYS.modalConfigNormalClass, backdrop: "static", initialState: { hdFlag: this.editMoreInfoFlag } }
      if (this.editMoreInfoFlag == true) {
        if (e.column.colDef.headerName == 'Delete') {
        }
        else {
          if (this.editMoreInfoFlag == true) {
            let moreInfoEdit = this.moreInfoList.filter((id: any) => id.more_info_id == this.moreInfoId);
            config = {
              class: KEYS.modalConfigNormalClass, backdrop: "static",
              initialState: { hdFlag: this.editMoreInfoFlag, moreInfoEdit: moreInfoEdit }
            }
          }
          this.modalRef = this.modalService.show(AddMoreinfoTabSettingComponent, config);
          this.modalRef.content.formSubmitEvent.subscribe((res: any) => {
            if (res) {
              if (this.editMoreInfoFlag == true) {
                this.updateMoreInfoTab(res)
              } else {
                this.addMoreInfoTab(res)
              }
            }
          });
        }
      }
      else {
        this.modalRef = this.modalService.show(AddMoreinfoTabSettingComponent, config);
        this.modalRef.content.formSubmitEvent.subscribe((res: any) => {
          if (res) {
            if (this.editMoreInfoFlag == true) {
              this.updateMoreInfoTab(res)
            } else {
              this.addMoreInfoTab(res)
            }
          }
        });
      }
    }
  }

  addMoreInfoTab(moreinfoModel: any) {
    let accountID = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.commonService.saveMoreInfoTabSetting(moreinfoModel, accountID).subscribe((data: any) => {
      if (isData(data)) {
        const pKey = data['table'][0]['primarykey'];
        this.SaveauditTrialData(pKey, moreinfoModel, 'insert');
      }
      this.gridOptions.rowData = [];
      this.loadMoreInfoTabSetting();
      //this.toastr.success(this.labelMessages.moreInfoTabConfirmation.save_success_msg);
        this.commonService.showModalValidate(this.labelMessages.moreInfoTabConfirmation.save_success_msg,'',this.messageLabel.static_messages.info,this.labelMessages.moreInfoTabConfirmation.save_success_msg);
    },
      error => {
        this.commonService.ogLog('Save MoreInfo Error:', error);
      });
  }

  updateMoreInfoTab(moreinfoModel: any) {
    let accountID = this.commonService.getUserCredentials(KEYS.credential_account_id);
    this.commonService.saveMoreInfoTabSetting(moreinfoModel, accountID).subscribe((data: any) => {
      this.SaveauditTrialData(this.moreInfoId, moreinfoModel, 'update');
      this.gridOptions.rowData = [];
      this.loadMoreInfoTabSetting();
      //this.toastr.success(this.labelMessages.moreInfoTabConfirmation.update_success_msg);
        this.commonService.showModalValidate(this.labelMessages.moreInfoTabConfirmation.update_success_msg,'',this.messageLabel.static_messages.info,this.labelMessages.moreInfoTabConfirmation.update_success_msg);
    },
      error => {
        this.commonService.ogLog('Update moreinfo Error:', error);
      });
  }
  setSize(params: any) {
    params.api.sizeColumnsToFit();
  }
  SaveauditTrialData(pKey: any, userData: any, action: any) {
    let compareData
    let inputLabel = '', firstinpuLable = '', ipaddress = '', machine = '';
    let userType = (userData.selectType == 1 ? this.selectTypeOption[0].name : this.selectTypeOption[1].name);
    let active = (userData.active == 1 ? 'active' : 'Inactive');
    this.commonService.ogLog('userdta:', userData, compareData)
    if (action == 'update') {
      if (this.moreInfoList) {
        compareData = this.moreInfoList.filter((id: any) => id.more_info_id == pKey);
      }
      firstinpuLable = 'Record Id :' + " ~~ " + pKey + "~~~"
      if (compareData) {

        let compareActive = (compareData[0].gstibo_isactive == 1 ? 'active' : 'Inactive');
        if (compareData[0].more_info_tab_id != userData.tabPageId) {
          inputLabel = inputLabel + 'More Info PageId' + " ~~ " + userData.tabPageId + " ~ " + (isNullOrUndefined(compareData[0].more_info_tab_id) ? '' : compareData[0].more_info_tab_id) + "~~~"
        }
        if (compareData[0].gstibo_linked_table != userData.linkedPageId) {
          inputLabel = inputLabel + 'Linked Pagename' + " ~~ " + userData.linkedPageId + " ~ " + (isNullOrUndefined(compareData[0].gstibo_linked_table) ? '' : compareData[0].gstibo_linked_table) + "~~~"
        }
        if (compareData[0].linked_column != userData.linkedcolumn) {
          inputLabel = inputLabel + 'Linked Column' + " ~~ " + userData.linkedcolumn + " ~ " + (isNullOrUndefined(compareData[0].linked_column) ? '' : compareData[0].linked_column) + "~~~"
        }
        if (compareData[0].gstibo_isactive != userData.active) {
          inputLabel = inputLabel + 'Active' + " ~~ " + active + " ~ " + (isNullOrUndefined(compareData[0].gstibo_isactive) ? '' : compareActive) + "~~~"
        }
      }

    }
    else {
      inputLabel = 'Record Id :' + " ~~ " + pKey + "~~~",
        inputLabel = inputLabel + 'More Info PageId ' + " ~~ " + userData.tabPageId + "~~~",
        inputLabel = inputLabel + 'Linked Pagename' + " ~~ " + userData.linkedPageId + "~~~",
        inputLabel = inputLabel + 'Linked Column' + " ~~ " + userData.linkedcolumn + "~~~",
        inputLabel = inputLabel + 'Active' + " ~~ " + active + "~~~"
    }
    if (inputLabel != '') {
      this.commonService.saveAuditTrialStatic(this.pageId, action, ipaddress, machine, this.commonService.getUserCredentials(KEYS.credential_account_id), inputLabel, pKey, '').subscribe((data: any) => {
      },
        error => {
          console.log('generateAuditTrail Error:', error);
        });
    }
  }
  deleteMoreInfoTab(e: any) {
    if (this.deleteright == 'true') {
      let moreinfoId = e.rowData.id;
      let validCheck = e.rowData.is_valid;
      let messagelabel = this.labelMessages.delete_confirm_msg.message
      if (validCheck == 'Yes') {
        messagelabel = this.moreInfoDeleteLabelActive.message;
      }
      let accountID = this.commonService.getUserCredentials(KEYS.credential_account_id);
      
      const modaldata = {
        title: this.labelMessages.delete_confirm_msg.title,
        message: messagelabel,
        btnConfirm: this.moreInfoDeleteLabel.buttontitleconfirm,
        btnCancel: this.moreInfoDeleteLabel.buttontitlecancel,
        btnConfirmStyle: 'btn-red',
        btnCancelStyle: 'btn-green'
      }
      this.commonService.showConfirmationModal(modaldata.title, modaldata.message, modaldata.message, modaldata.btnConfirm, modaldata.btnCancel, KEYS.dialogueType.DELETE).subscribe((res: any) => {
        if (res) {
          this.commonService.deleteMoreInfoTabSetting(moreinfoId).subscribe((data: any) => {
            this.gridOptions.rowData = [];
            this.ngOnInit();
            this.SaveauditTrialData(moreinfoId, res, 'delete');
            //this.toastr.success(this.labelMessages.holiday_confirm.delete_success_msg);
              this.commonService.showModalValidate(this.labelMessages.holiday_confirm.delete_success_msg,'',this.messageLabel.static_messages.info,this.labelMessages.holiday_confirm.delete_success_msg);
          });
        }
      });
    }
  }

}
